/**
 * Look up an Indian pincode for a locality via the public India Post API.
 * Returns the first matching 6-digit pincode, or '' if none found.
 */
export async function fetchPincodeForLocality(area, { city = '', state = 'Gujarat' } = {}) {
  const name = String(area || '')
    .replace(/\s*\(.*?\)\s*/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!name || name.toLowerCase().startsWith('other')) return '';

  try {
    const res = await fetch(
      `https://api.postalpincode.in/postoffice/${encodeURIComponent(name)}`
    );
    const data = await res.json();
    if (!Array.isArray(data) || data[0]?.Status !== 'Success') return '';

    const offices = data[0].PostOffice || [];
    if (!offices.length) return '';

    const stateLc = String(state || '').toLowerCase();
    const cityLc = String(city || '').toLowerCase();

    const preferred =
      offices.find(
        (o) =>
          (!stateLc || String(o.State || '').toLowerCase() === stateLc) &&
          (!cityLc ||
            String(o.District || '').toLowerCase().includes(cityLc) ||
            String(o.Block || '').toLowerCase().includes(cityLc) ||
            String(o.Name || '').toLowerCase().includes(cityLc))
      ) ||
      offices.find((o) => !stateLc || String(o.State || '').toLowerCase() === stateLc) ||
      offices[0];

    const pin = String(preferred?.Pincode || '').replace(/\D/g, '');
    return pin.length === 6 ? pin : '';
  } catch {
    return '';
  }
}
